// extracted by mini-css-extract-plugin
module.exports = {"btn":"PdfButton_btn__2m7qt"};